import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, Validator } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { MatDialog } from '@angular/material/dialog';
import { Listas } from 'src/app/models/generic/Listas';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { Operaciones_ReembolsoService } from 'src/app/services/operaciones_reembolso.service';
import { Operaciones_Reembolso_Lista } from 'src/app/models/generic/Operaciones_Reembolso_Lista';

@Component({
  selector: 'operaciones-reembolso-actualizar',
  templateUrl: './operaciones-reembolso-actualizar.component.html',
  styleUrls: ['./operaciones-reembolso-actualizar.component.scss']
})
export class OperacionesReembolsoActualizarComponent implements OnInit{
  
  @Output() TerminoGuardarRegistro = new EventEmitter();
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('modaloperacionesreembolso', {static: false}) _ModalOperacionesReembolso: TemplateRef<any>;
  listasCompletas: Listas[] = [];
  listasAliados: Listas[] = [];
  listasCanales: Listas[] = [];
  listasIndicativos: Listas[] = [];
  listasProductos: Listas[] = [];
  listasDepartamento: Listas[] = [];
  listasCiudades: Listas[] = [];
  listasMotivos: Listas[] = [];
  confirmacionModal: any;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Operaciones_ReembolsoService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService,
    public modal: MatDialog) {}

  ngOnInit() {
    
  }

  public AbrirModal() {
    this.ConsultarListas();
    this.IniciarFormulario();

    this.confirmacionModal = this.modal.open(this._ModalOperacionesReembolso, {
      panelClass: 'app-operaciones-reembolso-modal',
      position: {left: '0px', top: '0px'}
    });
  }

  public CrearAbrirModal(direccion: string,
    codigoPais: string,
    codigoProvincia: string,
    codigoCiudad: string
  ) {
    this.IniciarFormulario();
    
    this.form.get('codigoPaisIndicativo').setValue(codigoPais);
    this.form.get('codigoProvincia').setValue(codigoProvincia);
    this.form.get('codigoCiudad').setValue(codigoCiudad);
    this.form.get('domicilio').setValue(direccion);

    this.ConsultarListas();

    this.confirmacionModal = this.modal.open(this._ModalOperacionesReembolso, {
      panelClass: 'app-operaciones-reembolso-modal',
      position: {left: '0px', top: '0px'}
    });
  }

  public EditarAbrirModal(itemModificar: Operaciones_Reembolso_Lista) {
    this.IniciarFormulario();
    
    this.form.get('id').setValue(itemModificar.id);
    this.form.get('nroDocumento').setValue(itemModificar.nroDocumento);
    this.form.get('nombres').setValue(itemModificar.nombres);
    this.form.get('apellidos').setValue(itemModificar.apellidos);
    this.form.get('codigoPaisIndicativo').setValue(itemModificar.codigoIndicativo);
    this.form.get('indicativo').setValue(itemModificar.indicativo);
    this.form.get('nroCelular').setValue(itemModificar.nroCelular);
    this.form.get('email').setValue(itemModificar.email);
    this.form.get('idAliado').setValue(itemModificar.idAliado);
    this.form.get('idCanal').setValue(itemModificar.canal);
    this.form.get('idProducto').setValue(itemModificar.idProducto);
    this.form.get('codigoProvincia').setValue(itemModificar.codigoProvincia);
    this.form.get('provincia').setValue(itemModificar.provincia);
    this.form.get('codigoCiudad').setValue(itemModificar.codigoCiudad);
    this.form.get('ciudad').setValue(itemModificar.ciudad);
    this.form.get('domicilio').setValue(itemModificar.domicilio);
    this.form.get('motivo').setValue(itemModificar.motivo);
    this.form.get('expediente').setValue(itemModificar.expediente);

    this.ConsultarListas(false);

    this.confirmacionModal = this.modal.open(this._ModalOperacionesReembolso, {
      panelClass: 'app-operaciones-reembolso-modal',
      position: {left: '0px', top: '0px'}
    });
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      nroDocumento: ['', [Validators.required, Validators.maxLength(20)]],
      nombres: ['', [Validators.required, Validators.maxLength(100)]],
      apellidos: ['', [Validators.required, Validators.maxLength(100)]],
      codigoPaisIndicativo: ['', [Validators.required]],
      indicativo: [''],
      nroCelular: ['', [Validators.required, Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
      idAliado: [0, [Validators.min(1)]],
      idCanal: [0, [Validators.min(1)]],
      idProducto: [0, [Validators.min(1)]],
      codigoProvincia: ['', [Validators.required]],
      provincia: [''],
      codigoCiudad: ['', [Validators.required]],
      ciudad: [''],
      domicilio: ['', [Validators.required, Validators.maxLength(100)]],
      motivo: ['', [Validators.required]],
      expediente: ['', [Validators.required, Validators.maxLength(50)]],
    });
  }

  Guardar() {
    if (!this.mostrarCargando) {
      console.log(this.form.valid);
      if (this.form.valid) {
        this._appconfirmacion.MostrarMensajeConfirmacion();
      } else {
        this.utilitariosService.MostrarErroresFormulario(this.form);
      }
    }
  }
  Cancelar() {
    this.confirmacionModal.close();
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.mostrarCargando = true;

      let formularioGuardar = this.fb.group({
        id: [0],
        nroDocumento: [''],
        nombres: [''],
        apellidos: [''],
        codigoPaisIndicativo: [''],
        indicativo: [''],
        nroCelular: [''],
        email: [''],
        idAliado: [0],
        idCanal: [0],
        idProducto: [0],
        motivo: [''],
        codigoProvincia: [''],
        provincia: [''],
        codigoCiudad: [''],
        ciudad: [''],
        domicilio: [''],
        expediente: [''],
      });

      formularioGuardar.get('id').setValue(this.form.get('id').value);
      formularioGuardar.get('nroDocumento').setValue(this.form.get('nroDocumento').value);
      formularioGuardar.get('nombres').setValue(this.form.get('nombres').value);
      formularioGuardar.get('apellidos').setValue(this.form.get('apellidos').value);
      formularioGuardar.get('codigoPaisIndicativo').setValue(this.form.get('codigoPaisIndicativo').value);
      formularioGuardar.get('indicativo').setValue(this.form.get('indicativo').value);
      formularioGuardar.get('nroCelular').setValue(this.form.get('nroCelular').value);
      formularioGuardar.get('email').setValue(this.form.get('email').value);
      formularioGuardar.get('idAliado').setValue(this.form.get('idAliado').value);
      formularioGuardar.get('idCanal').setValue(this.form.get('idCanal').value);
      formularioGuardar.get('idProducto').setValue(this.form.get('idProducto').value);
      formularioGuardar.get('motivo').setValue(this.form.get('motivo').value);
      formularioGuardar.get('codigoProvincia').setValue(this.form.get('codigoProvincia').value);
      formularioGuardar.get('provincia').setValue(this.form.get('provincia').value);
      formularioGuardar.get('codigoCiudad').setValue(this.form.get('codigoCiudad').value);
      formularioGuardar.get('ciudad').setValue(this.form.get('ciudad').value);
      formularioGuardar.get('domicilio').setValue(this.form.get('domicilio').value);
      formularioGuardar.get('expediente').setValue(this.form.get('expediente').value);

      this.datosServices.Actualizar(formularioGuardar.value)
                .subscribe((resp: RespuestaGenerica) =>{
                  this.mostrarCargando = false;
                  
                  if (resp.procesoExitoso) {
                    this.confirmacionModal.close();
                    this.TerminoGuardarRegistro.emit();
                  } else {
                    this.utilitariosService.MensajeToast(resp.mensaje);
                  }
  
                  this.mostrarCargando = false;
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarListas(asignarValoresDefecto: boolean = true) {
    this.mostrarCargando = true;
    this.datosServices.ConsultarListas()
              .subscribe((resp: Listas[]) =>{
                this.mostrarCargando = false;
                this.listasCompletas = resp;
                
                this.listasAliados = this.listasCompletas.filter(x => x.lista === 'ALIADOS');
                this.listasIndicativos = this.listasCompletas.filter(x => x.lista === 'INDICATIVOS');
                this.listasDepartamento = this.listasCompletas.filter(x => x.lista === 'PROVINCIAS');
                this.listasMotivos = this.listasCompletas.filter(x => x.lista === 'MOTIVOS');

                if (asignarValoresDefecto) {
                  if (this.listasAliados.length === 1) {
                    this.form.get('idAliado').setValue(this.listasAliados[0].id);
                  }
                  if (this.listasIndicativos.length === 1) {
                    this.form.get('codigoPaisIndicativo').setValue(this.listasIndicativos[0].codigo);
                  }
                  if (this.listasDepartamento.length === 1) {
                    this.form.get('codigoProvincia').setValue(this.listasDepartamento[0].codigo);
                  }
                  if (this.listasMotivos.length === 1) {
                    this.form.get('motivo').setValue(this.listasMotivos[0].codigo);
                  }
                }
            
                this.RecargarListaCanales(asignarValoresDefecto);
                this.RecargarListaCiudades(asignarValoresDefecto);
                this.RecargarListaProductos(asignarValoresDefecto);

                if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('codigoProvincia').value)) {
                  if (this.listasDepartamento.filter(x => x.codigo === this.form.get('codigoProvincia').value).length > 0) {
                    this.Cambio_Provincia();
                  }
                }
                if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('codigoCiudad').value)) {
                  if (this.listasCiudades.filter(x => x.codigo === this.form.get('codigoCiudad').value).length > 0) {
                    this.Cambio_Ciudad();
                  }
                }
                if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('codigoPaisIndicativo').value)) {
                  if (this.listasIndicativos.filter(x => x.codigo === this.form.get('codigoPaisIndicativo').value).length > 0) {
                    this.Cambio_Indicativo();
                  }
                }

                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  Cambio_Aliado() {
    this.RecargarListaCanales();
    this.RecargarListaProductos();
  }
  Cambio_Provincia() {
    this.RecargarListaCiudades();
    this.form.get('provincia').setValue(this.listasDepartamento.filter(x => x.codigo === this.form.get('codigoProvincia').value)[0].descripcion);
  }
  Cambio_Ciudad() {
    this.form.get('ciudad').setValue(this.listasCiudades.filter(x => x.codigo === this.form.get('codigoCiudad').value)[0].descripcion);
  }
  Cambio_Indicativo() {
    this.form.get('indicativo').setValue(this.listasIndicativos.filter(x => x.codigo === this.form.get('codigoPaisIndicativo').value)[0].id);
  }
  Cambio_Producto() {
    let itemSeleccionado = this.listasProductos.filter(x => x.dependienciaId === this.form.get('idAliado').value && x.id === this.form.get('idProducto')?.value)[0];
    if (this.utilitariosService.VerificarContieneDatos(itemSeleccionado)) {
      if (this.utilitariosService.VerificarContieneDatosNumerico(itemSeleccionado.condicionEntero1)) {
        this.form.get('idCanal').setValue(itemSeleccionado.condicionEntero1);
      }
    }
  }
  RecargarListaCanales(asignarValorDefecto: boolean = true) {
    this.listasCanales = this.listasCompletas.filter(x => x.lista === 'CANALES' && x.dependienciaId === this.form.get('idAliado').value);

    if (asignarValorDefecto) {
      if (this.listasCanales.length === 1) {
        this.form.get('idCanal').setValue(this.listasCanales[0].id);
      }
    }
  }
  RecargarListaProductos(asignarValorDefecto: boolean = true) {
    this.listasProductos = this.listasCompletas.filter(x => x.lista === 'MAESTRO_PRODUCTOS' && x.dependienciaId === this.form.get('idAliado').value);

    if (asignarValorDefecto) {
      if (this.listasProductos.length === 1) {
        this.form.get('idProducto').setValue(this.listasProductos[0].id);
      }
    }
  }
  RecargarListaCiudades(asignarValorDefecto: boolean = true) {
    console.log('RecargarListaCiudades', asignarValorDefecto);
    this.listasCiudades = this.listasCompletas.filter(x => x.lista === 'CIUDADES' && x.dependenciaCodigo === this.form.get('codigoProvincia').value);

    if (asignarValorDefecto) {
      if (this.listasCiudades.length === 1) {
        this.form.get('codigoCiudad').setValue(this.listasCiudades[0].codigo);
      }
    }
  }
  ObtenerCodigoBandera(codigoIndicativo: string): string {
    let imagenRetorno: string = '';
    if (this.listasIndicativos) {
      if (this.listasIndicativos.filter(x => x.codigo === codigoIndicativo).length > 0) {
        imagenRetorno = this.listasIndicativos.filter(x => x.codigo === codigoIndicativo)[0].dependenciaCodigo;
      }
    }
    return imagenRetorno;
  }
  ObtenerIndicativo(codigoIndicativo: string): string {
    let imagenRetorno: string = '';
    if (this.listasIndicativos) {
      if (this.listasIndicativos.filter(x => x.codigo === codigoIndicativo).length > 0) {
        imagenRetorno = this.listasIndicativos.filter(x => x.codigo === codigoIndicativo)[0].id.toString();
      }
    }
    return imagenRetorno;
  }
  AltoContenido(): string {
    return `${window.innerHeight-125}px !important`;
  }
  AltoContenidoPrincipal(): string {
    return `${window.innerHeight}px !important`;
  }
}
